import bee from "./Bee";
export default {
    name: "Activate",
    /*
        var query = {
            code: "",
        }
    */
    /* eslint-disable no-unused-vars */
    activate_account(query, success, fail) {
        bee.token = null;
        bee.post({
            _f_verify: {
                app_name: "bws",
                code: query.code.toString(),
                hive_id: 1
            }
        }).then(res => {
            success(res);
        }).catch(errors => {
            fail(errors);
        });
    }
};